/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import { connect } from "react-redux";

//css class
import classes from "./provider.module.css";

import ContactDetails from "./contactDetails";

import Validator from "../../../helper/validator";

//message
import actionTypes from "../../../store/actions";

// API helper and constant
import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";

// Loader
import Loader from "../../../component/loader";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";
import Button from "../../../component/button";
import { Collapse, Tab } from "@mui/material";

import { withTranslation } from "react-i18next";
import { ExpandMore, CollapseMore } from "../../../component/icons/icons";
import MyTask from "./myTask";
import moment from "moment";
import { getStatesList, getStateName } from "../../../helper/getStateList.js";
import AddPartnerUser from "./addPartnerUser";
import Tabs from "@mui/material/Tabs";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Draggable from "react-draggable";
import {
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Tooltip from "@mui/material/Tooltip";
import { SearchIcon, ClearIcon } from "../../../component/icons/icons";
import { IconButton } from "@mui/material";
import Input from "../../../component/inputpm";
// import { withStyles } from '@mui/styles';
import { withNavigation } from "../../../helper/withNavigation.js";
class Provider extends Component {
  originalProviderData = {};
  providerDataTemplate = {
    name: "",
    type: "",
    description: "",
    role: "",
    contacts: [
      {
        name: "",
        email: "",
        phone: "",
        address: {
          attn: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          state: "",
          zipCode: "",
          country: "",
        },
        type: "ALL",
      },
    ],
  };
  originalloggedInUserData = {};
  loggedInUserDataTemplate = {
    banDetails: {
      ban: "",
      accountName: "",
    },
    billing: {
      attention: "",
      city: "",
      country: "",
      phone: "",
      state: "",
      street1: "",
      street2: "",
      zip: "",
    },
    contact: {
      firstName: "",
      lastName: "",
      partyId: "",
      officePhone: "",
      email: "",
      emailMechId: "",
      billingCloseDay: "",
      updateProfile: "Y",
    },
    shipping: {
      attention: "",
      city: "",
      country: "",
      phone: "",
      state: "",
      street1: "",
      street2: "",
      zip: "",
    },
  };
  state = {
    providerType: null,
    isUpdate: false,
    loading: false,
    contacts: [],
    showView: false,
    tenantId: "",
    edit: false,
    providerData: this.providerDataTemplate,
    expand: false,
    sortBy: "workEffortId",
    sortOrder: "DESC",
    orderId: "",
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalTasksCount: 0,
    tasksList: [],
    userId: "",
    userName: "",
    error: {},
    stateName: "",
    //create partner user
    showAddNewUser: false,
    userList: [],
    tabValue: 0,
    userEmailId: "",
    firstName: "",
    lasyName: "",
    loggedInUserData: this.loggedInUserDataTemplate,
    selectedUserData: {},
    isEditUser: false,

    allUsersList: [],
    selectedTask: {},
    showReassignTask: false,
    roleId: "",
    usersList: [],
    userId: "",

    taskEntityId: "",
    taskName: "",
    taskId: "",
    statusId: "",
    name: "",
    statusList: [
      {
        name: "Completed",
        value: "CAL_COMPLETED",
      },
      {
        name: "Acknowledged",
        value: "CAL_ACKNOWLEDGED",
      },
      {
        name: "Assigned",
        value: "CAL_ASSIGNED",
      },
      {
        name: "Waiting",
        value: "CAL_WAITING",
      },
    ],
  };
  constructor(props) {
    super(props);
    // Create a ref to access the child component
    this.childRef = React.createRef();
  }
  componentDidMount() {
    this.props.setErrorMessage();
    var search = new URLSearchParams(this.props.router.location.search);
    var type = search.get("type");
    if (type && type === "task") {
      this.setState({ tabValue: 1 }, () => {
        this.initialMount();
      });
    } else {
      this.setState({ tabValue: 0 }, () => {
        this.initialMount();
      });
    }
  }

  componentDidUpdate(prevProps) {
    const prevQuery = new URLSearchParams(prevProps.router.location.search).get("type");
    const currentQuery = new URLSearchParams(this.props.router.location.search).get("type");
    var search = new URLSearchParams(this.props.router.location.search);
    if (prevQuery !== currentQuery) {
      var type = search.get("type");
      if (type && type === "task") {
        this.setState({ tabValue: 1 }, () => {
          // this.initialMount();
        });
      } else {
        this.setState({ tabValue: 0 }, () => {
          // this.initialMount();
        });
      }
    }
  }

  initialMount = () => {
    let userRoles = JSON.parse(localStorage.getItem("roles"));
    this.setState({
      userId: userRoles.data.loggedInUser.userId,
      userName: userRoles.data.loggedInUser.userName,
      // userEmailId: userRoles.data.loggedInUser.email,
    });
    let providerData = { ...this.state.providerData };
    let loggedInUserData = { ...this.state.loggedInUserData };
    if (this.props.match) {
      providerData.type = this.props.router.params.providerType;
      this.setState({
        providerType: this.props.router.params.providerType,
        isUpdate: false,
        showView: true,
        providerData: providerData,
        loggedInUserData: loggedInUserData,
        edit: true,
      });
    } else {
      providerData.type = this.props.providerType;
      this.setState(
        {
          isUpdate: true,
          providerType: this.props.providerType,
          tenantId: this.props.tenantId,
          providerData: providerData,
          loggedInUserData: loggedInUserData,
          loading: true,
          edit: false,
        },
        () => {
          this.getProviderData();
        },
      );
    }

    this.getMyTasks();
    this.getMyTasksCount();
    this.getMyProfileDetails();
    this.getAllUserList();
  }

  getAllUserList = () => {
    var tenantData = JSON.parse(localStorage.getItem("roles"));
    var payload = {};
    console.log("check selectedTask", this.state.selectedTask);
    if (
      this.props.providerType !== "SOLUTION_PROVIDER" &&
      this.props.securityGroupsList.includes("ADMIN")
    ) {
      payload = {
        fromPartyId: this.state.tenantId,
        relationshipTypeId: "EMPLOYMENT",
        partyRoleId: this.state.selectedTask.assignedRoleId
          ? this.state.selectedTask.assignedRoleId
          : "",
      };
    } else {
      payload = {
        fromPartyId: tenantData.data.loggedInUser.partyId
          ? tenantData.data.loggedInUser.partyId
          : this.props.loggedInUserId,
        relationshipTypeId: "MANAGER",
      };
    }
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_RELATED_PARTIES/endpoint`,
      payload,
    )
      .then((res) => {
        this.setState({
          allUsersList: res.data,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
      });
  };

  //Called for all input fields
  onChange = (e) => {
    let data = { ...this.state.providerData };
    data[e.target.name] = e.target.value;
    let loggedInUserData = { ...this.state.loggedInUserData };
    if (e.target.name === "firstName")
      loggedInUserData.contact.firstName = e.target.value;
    if (e.target.name === "lastName")
      loggedInUserData.contact.lastName = e.target.value;
    if (e.target.name === "email")
      loggedInUserData.contact.email = e.target.value;
    this.setState({
      providerData: data,
      loggedInUserData: loggedInUserData,
    });
  };

  // Change contact
  onChangeContact = (e) => {
    let data = { ...this.state.providerData };
    let contact = { ...data.contacts[0] };
    contact[e.target.name] = e.target.value;
    data.contacts[0] = contact;
    this.setState({
      providerData: data,
    });
  };

  // Change address
  onChangeAddress = (e) => {
    let data = { ...this.state.providerData };
    let contact = { ...data.contacts[0] };
    let address = { ...contact.address };
    address[e.target.name] = e.target.value;
    contact.address = address;
    data.contacts[0] = contact;
    this.setState({
      providerData: data,
    });
  };

  // Featch provider details
  // getProviderData = () => {
  //     // let providerType = '';
  //     // let providerName = '';
  //     // if (this.props.providerType === 'SALES_CHNL_PROVIDER') {
  //     //     providerType = '/sales-channel-providers';
  //     //     providerName = this.props.t('SALES_CHANNEL_PROVIDER');
  //     // } else if (this.props.providerType === 'SOLUTION_PROVIDER') {
  //     //     providerType = '/solution-providers';
  //     //     providerName = this.props.t('SOLUTION_PROVIDER');
  //     // } else if (this.props.providerType === 'SERVICE_PROVIDER') {
  //     //     providerType = '/service-providers';
  //     //     providerName = this.props.t('SERVICE_PROVIDER');
  //     // }
  //     // BusApiCall('GET', `${constants.busV4Url}${providerType}`).then(res => {
  //     //     let providersList = res.data;
  //     //     if (providersList) {
  //     //         let provider = providersList.find(obj => this.state.tenantId === obj.id);
  //     //         if (provider.description === null) {
  //     //             provider.description = '';
  //     //         }
  //     //         if (provider && !provider.contacts[0].address) {
  //     //             provider.contacts[0].address = this.providerDataTemplate.contacts[0].address;
  //     //         }
  //     //         this.setState({
  //     //             providerData: provider,
  //     //             showView: true,
  //     //             loading: false,
  //     //         })
  //     //     } else {
  //     //         this.setState({
  //     //             providerData: {},
  //     //             showView: true,
  //     //             loading: false,
  //     //         })
  //     //     }
  //     // })
  //     let pageOptions = {
  //         batchSize: this.state.rowsPerPage,
  //         startRecord: this.state.startRecord,
  //     };

  //     Promise.all([
  //         BusApiCall('GET', `${constants.busV4Url}/myProfile`),
  //         BusApiCall('GET', `${constants.busV4Url}/myTasks?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&orderId=${this.state.orderId}&statusId=${this.state.statusId}&name=${this.state.name}`, {}, pageOptions),

  //     ]).then(res => {
  //         this.providerDataTemplate = {...res[0].data}
  //         this.providerDataTemplate.name = res[0].data.firstName + ' ' + res[0].data.lastName;
  //         this.providerDataTemplate.role = res[0].data.role;
  //         this.setState({
  //             providerData: this.providerDataTemplate,
  //             tasksList: res[1].data,
  //             totalTasksCount: +res[1].headers['x-total-count'],
  //             showView: true,
  //             loading: false,

  //         })

  //     })
  //     .catch(err => {
  //         // Error handling
  //         if (err.response && err.response.data && err.response.data.message) {
  //             this.props.setErrorMessage(err.response.data.message, false)
  //         } else {
  //             this.props.setErrorMessage('Something went wrong', false)
  //         }
  //         this.setState({ loading: false })
  //     })

  // }

  getProviderData = () => {
    let providerType = "";
    let providerName = "";
    if (this.props.providerType === "SALES_CHNL_PROVIDER") {
      providerType = "/sales-channel-providers";
      providerName = this.props.t("SALES_CHANNEL_PROVIDER");
    } else if (this.props.providerType === "SOLUTION_PROVIDER") {
      providerType = "/solution-providers";
      providerName = this.props.t("SOLUTION_PROVIDER");
    } else if (this.props.providerType === "SERVICE_PROVIDER") {
      providerType = "/service-providers";
      providerName = this.props.t("SERVICE_PROVIDER");
    }
    BusApiCall("GET", `${constants.busV4Url}${providerType}`).then((res) => {
      let providersList = res.data;
      if (providersList) {
        let provider = providersList.find(
          (obj) => this.state.tenantId === obj.id,
        );
        if (provider.description === null) {
          provider.description = "";
        }
        if (provider && !provider.contacts[0].address) {
          provider.contacts[0].address =
            this.providerDataTemplate.contacts[0].address;
        }
        this.setState(
          {
            providerData: provider,
            // showView: true,
            // loading: false,
          },
          () => {
            if (
              this.state.providerData.contacts &&
              this.state.providerData.contacts.length > 0 &&
              this.state.providerData.contacts[0].address
            ) {
              if (
                this.state.providerData.contacts[0].address.country &&
                this.state.providerData.contacts[0].address.state
              ) {
                this.setStateName(
                  this.state.providerData.contacts[0].address.country,
                  this.state.providerData.contacts[0].address.state,
                );
              } else {
                if (this.state.providerData.contacts[0].address.state) {
                  this.setState({
                    stateName:
                      this.state.providerData.contacts[0].address.state,
                    showView: true,
                    loading: false,
                  });
                } else {
                  this.setState({
                    stateName: "",
                    showView: true,
                    loading: false,
                  });
                }
              }
            }
          },
        );
      } else {
        this.setState({
          providerData: {},
          showView: true,
          loading: false,
        });
      }
    });
  };

  getMyProfileDetails = () => {
    this.setState({
      loading: true,
      edit: false,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    BusApiCall("GET", `${constants.busV4Url}/myProfile`, {}, pageOptions)
      .then((res) => {
        let myProfileData = res.data;
        this.setState({ edit: false });
        if (myProfileData) {
          var tempUserName =
            (myProfileData?.firstName || "") +
            " " +
            (myProfileData?.lastName || "");
          var rolesData = JSON.parse(localStorage.getItem("roles"));
          rolesData.data.loggedInUser.userName = tempUserName;
          localStorage.setItem("roles", JSON.stringify(rolesData));
          this.props.setUserName(tempUserName);
          this.setState((prevState) => ({
            firstName: myProfileData?.firstName || "",
            lastName: myProfileData?.lastName || "",
            userEmailId: myProfileData?.email || "",
            // loading: false,
            loggedInUserData: {
              ...prevState.loggedInUserData, // Keep existing data
              contact: {
                ...prevState.loggedInUserData.contact,
                firstName: myProfileData?.firstName || "",
                lastName: myProfileData?.lastName || "",
                email: myProfileData?.email || "",
                emailMechId: myProfileData?.emailMechId || "",
              },
            },
          }));
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  getMyTasks = () => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    BusApiCall(
      "GET",
      `${constants.busV4Url}/myTasks?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&orderId=${this.state.orderId}&taskId=${this.state.taskId}&taskName=${this.state.taskName}&statusId=${this.state.statusId}&name=${this.state.name}&taskEntityId=${this.state.taskEntityId}`,
      {},
      pageOptions,
    )
      .then((res) => {
        this.setState({
          tasksList: res.data,
          totalTasksCount: +res.headers["x-total-count"],
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  getMyTasksCount = () => {
    var tenantData = JSON.parse(localStorage.getItem("roles"));
    var payload = {
      partyId: tenantData.data.loggedInUser.partyId
        ? tenantData.data.loggedInUser.partyId
        : "",
    };
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_PENDING_TASKS_COUNT/endpoint`,
      payload,
    )
      .then((res) => {
        this.props.setPendingTaskCount(res.data.pendingTasksCount);
      })
      .catch((err) => {
        // if (err.response && err.response.data && err.response.data.message) {
        //     this.props.setErrorMessage(err.response.data.message, false);
        // } else {
        //     this.props.setErrorMessage(this.props.t("DEFAULT_ERROR_MESSAGE"), false);
        // }
      });
  };

  validateProfileFormData = () => {
    const error = {};
    let form = this.state.loggedInUserData;
    let t = this.props.t;
    if (!form.contact.firstName) {
      error.firstName = t("FIRST_NAME_IS_REQUIRED");
    }
    if (!form.contact.email) {
      error.email = t("EMAIL_IS_REQUIRED");
    } else if (!/\S+@\S+\.\S+/.test(form.contact.email)) {
      error.email = t("EMAIL_IS_INVALID");
    }
    this.setState({ error });
    this.setState({
      loading: false,
    });
    if (Object.keys(error).length === 0) {
      return true;
    }
  };

  validateFormData = () => {
    const error = {};
    let form = this.state.providerData;
    let t = this.props.t;
    if (!form.name) {
      error.name = t("PROVIDER_NAME_ERROR");
    }
    if (!form.contacts[0].name) {
      error.contacts = t("CONTACT_NAME_ERROR");
    }
    if (!this.validatePhoneNo(form.contacts[0].phone)) {
      error.phone = t("INVALID_PHONE_NUMBER_ERROR");
    }
    if (!form.contacts[0].email) {
      error.email = t("EMAIL_IS_REQUIRED");
    } else if (!/\S+@\S+\.\S+/.test(form.contacts[0].email)) {
      error.email = t("EMAIL_IS_INVALID");
    }
    //  else if (!Validator.Email(form.contacts[0].email)) {
    //     this.props.setErrorMessage(msg.wrong_email)
    // }
    if (!form.contacts[0].address.attn) {
      error.attn = t("ATTN_ERROR");
    }
    if (!form.contacts[0].address.addressLine1) {
      error.addressLine1 = t("ADDRESS_LINE1_ERROR");
    }
    if (!form.contacts[0].address.city) {
      error.city = t("CITY_ERROR");
    }
    if (!form.contacts[0].address.state) {
      error.state = t("STATE_ERROR");
    }
    if (!form.contacts[0].address.country) {
      error.country = t("COUNTRY_ERROR");
    }
    // if (!form.contacts[0].address.zipCode) {
    //     error.zipCode = t("ZIP_CODE_ERROR");
    // }
    this.setState({ error });
    this.setState({
      loading: false,
    });
    if (Object.keys(error).length === 0) {
      return true;
    }
  };

  updateError = (val) => {
    this.setState({
      error: {
        ...this.state.error,
        [val]: "",
      },
    });
  };

  validatePhoneNo = (val) => {
    // if (val) {
    //     var pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    //     return pattern.test(val)
    // }
    // return true
    const mobileNumberRegex =
      /^[+]?[0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$|^[\+][1][-][0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$/;
    if (!mobileNumberRegex.test(val)) {
      return false;
    }
    return true;
  };

  cancelData = () => {
    this.state.providerData = JSON.parse(
      JSON.stringify(this.originalProviderData),
    );
    this.state.loggedInUserData = JSON.parse(
      JSON.stringify(this.originalloggedInUserData),
    );
    this.setState({
      edit: false,
      error: {},
    });
  };

  submitProfileData = () => {
    if (this.validateProfileFormData()) {
      this.setState({
        loading: true,
      });
      let data = { ...this.state.loggedInUserData };
      BusApiCall("POST", `${constants.busInternalUrl}/customers`, data)
        .then((res) => {
          this.props.setErrorMessage(
            this.props.t("DATA_UPDATED_SUCCESSFULLY"),
            true,
          );
          this.getMyProfileDetails();
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
          });
        });
    }
  };

  submitData = () => {
    //output the passed details
    if (this.validateFormData()) {
      this.setState({
        loading: true,
      });
      let providerName = "";
      let providerType = "";
      if (this.state.providerType === "SALES_CHNL_PROVIDER") {
        providerType = "/sales-channel-providers";
        providerName = this.props.t("SALES_CHANNEL_PROVIDER");
      } else if (this.state.providerType === "SOLUTION_PROVIDER") {
        providerType = "/solution-providers";
        providerName = this.props.t("SOLUTION_PROVIDER");
      } else if (this.state.providerType === "SERVICE_PROVIDER") {
        providerType = "/service-providers";
        providerName = this.props.t("SERVICE_PROVIDER");
      }
      if (this.state.isUpdate) {
        let data = { ...this.state.providerData };
        delete data.typeEnum;
        delete data.id;
        delete data.contacts[0].address.addressType;
        BusApiCall(
          "PATCH",
          `${constants.busV4Url}${providerType}/${this.state.tenantId}`,
          data,
        )
          .then((res) => {
            this.props.setErrorMessage(
              this.props.t("DATA_UPDATED_SUCCESSFULLY"),
              true,
            );
            this.setState({
              loading: false,
              edit: false,
            });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      } else {
        BusApiCall(
          "POST",
          `${constants.busV4Url}${providerType}`,
          this.state.providerData,
        )
          .then((res) => {
            let message = {
              providerName: providerName,
            };
            this.props.setErrorMessage(
              this.props.t("PROVIDER_CREATED_MESSAGE", { message }),
              true,
            );
            this.props.router.navigate("/dashboard");
            this.setState({
              loading: false,
            });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      }
    }
  };

  safeTrim = (value) => {
    if (value == null) return ''; // handles null & undefined
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'number') return String(value);
    if (typeof value === 'boolean') return value;
    if (Array.isArray(value)) return value.join(', ').trim();
    if (typeof value === 'object') return JSON.stringify(value).trim();
    return '';
  }

  updateTheme = () => {
    if (this.state.logoPreview || this.state.themeColor) {
      if (this.state.logoPreview !== null || this.state.themeColor !== null) {
        let data = {};
        data.logo = this.state.logoPreview
          ? this.state.logoPreview
          : this.props.tenantData.logo;
        data.themeColor = this.state.themeColor
          ? this.state.themeColor
          : this.props.tenantData.color;
        BusApiCall("PATCH", `${constants.busV4Url}/theme`, data)
          .then((res) => {
            this.props.setErrorMessage(
              this.props.t("DATA_UPDATED_SUCCESSFULLY"),
              true,
            );
            BusApiCall(
              "GET",
              `${constants.busInternalUrl}/tenants/${this.props.tenantId}/themes`,
            )
              .then((salesChannelData) => {
                // localStorage.setItem(
                //   "themeData",
                //   JSON.stringify(salesChannelData),
                // );
                // let tenantData = {};
                // for (var i = 0; i < salesChannelData.data.length; i++) {
                //   tenantData[salesChannelData.data[i].key] =
                //     salesChannelData.data[i].value;
                // }
                var tempThemeData = {
                  data: [],
                };
                tempThemeData.data = salesChannelData.data.map((item) => ({
                  ...item,
                  value: this.safeTrim(item.value),
                }));
                let tenantData = {};
                for (var i = 0; i < salesChannelData.data.length; i++) {
                  tenantData[salesChannelData.data[i].key] = this.safeTrim(
                    salesChannelData.data[i].value,
                  );
                }
                localStorage.setItem(
                  "themeData",
                  JSON.stringify(tempThemeData),
                );
                if (tenantData["menuOrientation"]) {
                  if (tenantData["menuOrientation"].toLowerCase() === "top") {
                    localStorage.setItem("sideMenu", false);
                    localStorage.setItem("showBucketsOnLeft", false);
                    this.props.setSideMenu(false);
                  } else {
                    localStorage.setItem("sideMenu", true);
                    localStorage.setItem("showBucketsOnLeft", true);
                    this.props.setSideMenu(true);
                  }
                } else {
                  localStorage.setItem("sideMenu", true); //fallback value incase menuorientaion key is missing is on the Left
                  localStorage.setItem("showBucketsOnLeft", true);
                  this.props.setSideMenu(true);
                }
                if (tenantData["showMyCustomerEnabled"]) {
                  localStorage.setItem(
                    "showMyCustomerEnabled",
                    tenantData["showMyCustomerEnabled"] === true
                      ? "true"
                      : "false",
                  );
                } else {
                  localStorage.setItem("showMyCustomerEnabled", "false");
                }

                // localStorage.setItem('sideMenu', false);
                // localStorage.setItem('showBucketsOnLeft', false);

                if (tenantData["showMyCustomerEnabled"]) {
                  localStorage.setItem(
                    "showMyCustomerEnabled",
                    tenantData["showMyCustomerEnabled"] === true
                      ? "true"
                      : "false",
                  );
                } else {
                  localStorage.setItem("showMyCustomerEnabled", "false");
                }
                this.props.setTenantData(tenantData);
                this.setState({
                  loading: false,
                });
              })
              .catch((error) => {
                console.log("error sales channel", error);
              });
            this.setState({
              // loading: false,
              edit: false,
            });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      }
    }
  };
  editProfile = () => {
    this.originalProviderData = JSON.parse(
      JSON.stringify(this.state.providerData),
    );
    this.originalloggedInUserData = JSON.parse(
      JSON.stringify(this.state.loggedInUserData),
    );
    this.setState({
      showView: true,
      edit: true,
    });
  };

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getMyTasks();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getMyTasks();
      },
    );
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getMyTasks();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getMyTasks();
        },
      );
    }
  };

  openTaskLink = (row) => {
    // window.open(`${constants.cbizBaseUrl}${url}&8f1-550-3c7-e8f=` + this.props.access_token + "&userTenantId=" + this.props.tenantId + "&57b-7ad-d6b-80c=582-204-65e-be0");
    if (row.taskPurpose === "NOTIFICATION" && row.statusId === "CAL_WAITING") {
      var payload = {
        statusId: "CAL_ACKNOWLEDGED",
      };
      // if (this.state.providerType === 'SOLUTION_PROVIDER') {
      //     if (row.assocTenantId) {
      //         payload.tenantId = row.assocTenantId;
      //     } else {
      //         if (row.infoUrl.includes('tenantId')) {
      //             var url = row.infoUrl;
      //             var params = new URLSearchParams(url.split('?')[1]);
      //             var tenantId = params.get('tenantId');
      //             payload.tenantId = tenantId;
      //         }
      //     }
      // }
      BusApiCall(
        "PUT",
        `${constants.busV44UrlPublic}/tasks/${row.taskId}/status`,
        payload,
      )
        .then((res) => {
          this.getMyTasks();
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    }
    if (row.assocTenantId) {
      var url = "";
      if (row.infoUrl.includes("tenantId")) {
        url = row.infoUrl;
      } else {
        url = row.infoUrl + "?tenantId=" + row.assocTenantId;
      }
      window.open(url, "_blank");
    } else {
      window.open(row.infoUrl, "_blank");
    }
  };

  setCountryName = (country) => {
    var index = this.props.countriesList.findIndex((a) => a.id === country);
    if (index > -1) {
      return this.props.countriesList[index].name;
    } else {
      return country;
    }
  };

  setStateName = (country, state) => {
    this.setState({
      loading: true,
    });
    getStateName(country, state)
      .then((res) => {
        this.setState({
          stateName: res,
          loading: false,
          showView: true,
        });
        return res;
      })
      .catch((err) => {
        this.setState({
          stateName: state,
          loading: false,
          showView: true,
        });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("FAILED_TO_LOAD_STATES"),
            false,
          );
        }
      });
    return state;
  };

  setLogoPreview = (logoPreview) => {
    this.setState({
      logoPreview: logoPreview,
    });
  };
  setThemeColor = (themeColor) => {
    this.setState({
      themeColor: themeColor,
    });
  };

  getUserList = () => {
    this.setState({
      loading: true,
    });
    BusApiCall("GET", `${constants.busV4Url}/solution-provider-user`, {})
      .then((res) => {
        this.setState({
          loading: false,
        });
        let userList = res.data;
        this.setState({
          userList: userList,
        });
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  createPartnerUser = (data) => {
    this.setState({
      loading: true,
    });
    BusApiCall("POST", `${constants.busV4Url}/solution-provider-user`, data)
      .then((res) => {
        this.setState({ loading: false });
        this.props.setErrorMessage(
          this.props.t("USER_CREATED_SUCCESSFULLY"),
          true,
        );
        this.handleToggleDialog();
        this.getUserList();
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  handleToggleDialog = () => {
    this.setState((prevState) => ({
      showAddNewUser: !prevState.showAddNewUser,
    }));
  };
  handleChange = (event, newValue) => {
    console.log("check change tab", event, newValue);
    this.setState({ tabValue: newValue });
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  selectReassignTask = (e, item) => {
    this.setState(
      {
        roleId: "",
        usersList: [],
        userId: "",
        selectedTask: item,
        showReassignTask: true,
      },
      () => {
        if (
          this.props.providerType !== "SOLUTION_PROVIDER" &&
          this.props.securityGroupsList.includes("ADMIN")
        ) {
          this.getAllUserList();
        }
      },
    );
  };

  onChangeRoleId = (e) => {
    var name = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => { },
    );
  };

  reassignTaskUser = (val) => {
    if (val) {
      var payload = {
        action: "REASSIGN_TASK",
        currentPartyId: this.state.selectedTask.assignedPartyId,
        assignToPartyId: this.state.userId,
        assignToPartyRole: this.state.selectedTask.assignedRoleId
          ? this.state.selectedTask.assignedRoleId
          : "",
      };
      console.log("check payload", payload);
      this.setState({
        loading: true,
      });
      BusApiCall(
        "PATCH",
        `${constants.busV44UrlPublic}/tasks/${this.state.selectedTask.taskId}`,
        payload,
      )
        .then((res) => {
          this.setState({ loading: false });
          this.props.setErrorMessage(
            this.props.t("TASK_REASSINED_SUCCESSFULLY"),
            true,
          );
          this.reassignTaskUser(false);
          this.getMyTasks();
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
          });
          this.reassignTaskUser(false);
        });
    } else {
      this.setState({
        selectedTask: {},
        showReassignTask: false,
        roleId: "",
        usersList: [],
        userId: "",
      });
    }
  };

  onChangeTaskFilters = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onSearchKeyDownOnTask = (e) => {
    if (e.key === "Enter") {
      this.searchTasksTable();
    }
  };

  searchTasksTable = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
        totalTasksCount: 0,
      },
      () => {
        this.getMyTasks();
      },
    );
  };

  clearTasksTableFilters = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
        totalTasksCount: 0,
        taskName: "",
        taskId: "",
        statusId: "",
        name: "",
        taskEntityId: "",
      },
      () => {
        this.getMyTasks();
      },
    );
  };

  showLoader = (val) => {
    this.setState({
      loading: val,
    })
  }

  //render
  render() {
    const t = this.props.t;
    const { error } = this.state;
    const { classes: jssClasses } = this.props;
    return (
      <main
        style={{
          margin: this.state.isUpdate ? "0 0" : "",
          paddingTop: this.state.isUpdate ? "0" : "",
        }}
      >
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Grid
              item
              style={{ paddingBottom: "1rem" }}
              size={{
                xs: 12,
              }}
            >
              <Box className={classes.tabUnderLine}>
                <Tabs
                  // indicatorColor="primary"
                  // textColor="primary"
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: this.props.tenantData.color, // Use dynamic color here
                    },
                  }}
                  scrollButtons="auto"
                  onChange={this.handleChange}
                  value={this.state.tabValue}
                  className={classes.createPackageTabs}
                >
                  <Tab value={0} label={t("PROFILE")} />
                  <Tab value={1} label={t("MY_TASK")} />
                  {this.state.providerType === "SOLUTION_PROVIDER" &&
                    !this.props.securityGroupsList.includes(
                      "PARTNER_EMPLOYEE",
                    ) && <Tab value={2} label={t("USERS")} />}
                </Tabs>
              </Box>
            </Grid>
            {/* <Box paddingTop={3} /> */}
          </Grid>

          {/* Contact Details for the Provider */}
          {this.state.tabValue === 0 && (
            <>
              {this.state.showView && this.state.edit ? (
                <Grid
                  container
                  spacing={3}
                  justifyContent="center"
                  alignItems="center"
                  style={{ justifyContent: "center" }}
                >
                  <Grid
                    item
                    style={{ position: "relative" }}
                    size={{
                      xs: 12,
                    }}
                  >
                    <Card variant="outlined" style={{ borderRadius: "8px" }}>
                      <CardContent>
                        <ContactDetails
                          onChange={this.onChange}
                          onChangeContact={this.onChangeContact}
                          onChangeAddress={this.onChangeAddress}
                          providerRole={this.state.providerType}
                          loggedInUserType={this.props.loggedInUserType}
                          tenantData={this.props.tenantData}
                          isUpdate={this.state.isUpdate}
                          cancelData={this.cancelData}
                          updateTheme={this.updateTheme}
                          submitData={this.submitData}
                          submitProfileData={this.submitProfileData}
                          providerData={this.state.providerData}
                          loggedInUserData={this.state.loggedInUserData}
                          error={this.state.error}
                          updateError={this.updateError}
                          logoPreview={this.state.logoPreview}
                          setLogoPreview={this.setLogoPreview}
                          themeColor={this.state.themeColor}
                          setThemeColor={this.setThemeColor}
                          securityGroupsList={this.props.securityGroupsList}
                        />
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={3}>
                  <Grid
                    item
                    style={{ position: "relative" }}
                    size={{
                      xs: 12,
                    }}
                  >
                    <Card variant="outlined" style={{ borderRadius: "8px" }}>
                      <CardContent>
                        <TableContainer>
                          <Table
                            className={
                              classes.noBorder + " " + classes.fontWeight
                            }
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  <h3 className={"no-margin"}>
                                    {t("PERSONAL_INFO")}
                                  </h3>
                                </TableCell>
                                <TableCell align="right">
                                  {
                                    // this.props.apiPermissions.includes("CUMULATOR_GET_SOLUTION_PROVIDER") &&
                                    this.props.userPerms.includes(
                                      "CUMULATOR-PROFILE_EDIT",
                                    ) && (
                                      <Button
                                        className={"buttonSecondary"}
                                        onClick={() => this.editProfile()}
                                      >
                                        <span style={{ marginRight: ".5rem" }}>
                                          <svg
                                            width="13"
                                            height="12"
                                            viewBox="0 0 13 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </span>
                                        {t("EDIT")}
                                      </Button>
                                    )
                                  }
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell style={{ width: 200 }}>
                                  {t("NAME")}
                                </TableCell>
                                <TableCell>
                                  {/* {this.state.userName} */}
                                  {`${this.state.firstName || ""} ${this.state.lastName || ""}`.trim()}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>{t("ID")}</TableCell>
                                <TableCell>{this.state.userId}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>{t("CONTACT_EMAIL")}</TableCell>
                                <TableCell>{this.state.userEmailId}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell style={{ width: 200 }}>
                                  {t("USER_ROLE")}
                                </TableCell>
                                <TableCell>
                                  {t(this.props.loggedInUserType)}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell style={{ width: 200 }}>
                                  {t("TENANT_NAME")}
                                </TableCell>
                                <TableCell>
                                  {this.props.tenantData.title}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </CardContent>
                    </Card>
                    {/* <Collapse in={this.state.expand} collapsedSize={75}> */}
                    {/* <Card variant='outlined' style={{ borderRadius: '8px', marginTop: '1rem' }}>
                                            <CardContent>
                                                <Table className={classes.noBorder + ' ' + classes.fontWeight}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell colSpan={2}>
                                                                <h3 className={'no-margin'}>{t('CONTACT_INFO')}</h3>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    {this.state.providerData && this.state.providerData.contacts &&
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell style={{ width: 200 }}>{t('NAME')}</TableCell>
                                                                <TableCell>{this.state.providerData.contacts[0].name}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>{t('NUMBER')}</TableCell>
                                                                <TableCell>{this.state.providerData.contacts[0].phone}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>{t('EMAIL')}</TableCell>
                                                                <TableCell>{this.state.providerData.contacts[0].email}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>{t('ATTENTION')}</TableCell>
                                                                <TableCell>{this.state.providerData.contacts[0].address.attn}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>{t('STREET1')}</TableCell>
                                                                <TableCell>{this.state.providerData.contacts[0].address.addressLine1}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>{t('STREET2')}</TableCell>
                                                                <TableCell>{this.state.providerData.contacts[0].address.addressLine2}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>{t('CITY')}</TableCell>
                                                                <TableCell>{this.state.providerData.contacts[0].address.city}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>{t('STATE')}</TableCell>
                                                                <TableCell>{this.state.stateName}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>{t('COUNTRY')}</TableCell>
                                                                <TableCell>{this.setCountryName(this.state.providerData.contacts[0].address.country)}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>{t('ZIP')}</TableCell>
                                                                <TableCell>{this.state.providerData.contacts[0].address.zipCode}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    }
                                                </Table>
                                            </CardContent>
                                        </Card> */}
                  </Grid>
                </Grid>
              )}
            </>
          )}
          {this.state.tabValue === 1 && (
            <>
              <div className={classes.searchOuterDiv}>
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("TASK_NAME")}
                    value={this.state.taskName}
                    name={"taskName"}
                    onChange={(e) => {
                      this.onChangeTaskFilters(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDownOnTask(e);
                    }}
                  />
                </div>
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("TASK_ENTITY_ID")}
                    value={this.state.taskEntityId}
                    name={"taskEntityId"}
                    onChange={(e) => {
                      this.onChangeTaskFilters(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDownOnTask(e);
                    }}
                  />
                </div>
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("TASK_ID")}
                    value={this.state.taskId}
                    name={"taskId"}
                    onChange={(e) => {
                      this.onChangeTaskFilters(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDownOnTask(e);
                    }}
                  />
                </div>
                {(this.props.securityGroupsList.includes("PARTNER_ADMIN") ||
                  this.props.securityGroupsList.includes("ADMIN")) && (
                    <div>
                      <Input
                        size={"small"}
                        variant={"outlined"}
                        placeholder={t("ASSIGNED_TO")}
                        value={this.state.name}
                        name={"name"}
                        onChange={(e) => {
                          this.onChangeTaskFilters(e);
                        }}
                        divClass={classes.inputClass}
                        onKeyDown={(e) => {
                          this.onSearchKeyDownOnTask(e);
                        }}
                      />
                    </div>
                  )}
                <div>
                  <Select
                    native
                    // size={'small'}
                    // style={{ width: "245px" }}
                    variant={"outlined"}
                    name={"statusId"}
                    inputProps={{
                      name: "statusId",
                      id: "outlined-native-statusId",
                    }}
                    //value={(a) => a.value}
                    value={this.state.statusId}
                    onChange={(e) => {
                      this.onChangeTaskFilters(e);
                    }}
                    onKeyDown={(e) => {
                      this.onSearchKeyDownOnTask(e);
                    }}
                  // selectClass={classes.inputClass + " " + classes.statusSelectBg + " " + classes.searchOrderSelect}
                  >
                    <option value={""}>All</option>
                    {this.state.statusList
                      .sort((a, b) => a.value.localeCompare(b.value))
                      .map((a) => (
                        <option key={a.value} value={a.value}>
                          {a.name}
                        </option>
                      ))}
                  </Select>
                </div>

                {/* <div className={classes.searchOrderLabelOuter}>
                                <div className={classes.searchOrderLabelInner}> */}
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <Tooltip title={t("SEARCH")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={this.searchTasksTable}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>{" "}
                  &nbsp;
                  <Tooltip title={t("CLEAR")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={this.clearTasksTableFilters}
                    >
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                </div>
                {/* </div> */}
              </div>
              <Grid
                container
                spacing={3}
                justifyContent="center"
                alignItems="center"
                style={{ justifyContent: "center" }}
              >
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <Card variant="outlined" style={{ borderRadius: "8px" }}>
                    {/* <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>
                                                        <h3 className={'no-margin'}>{t('MY_TASK')}</h3>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell align='center'>{t('NO_PENDING_TASK')}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table> */}
                    <MyTask
                      tasksList={this.state.tasksList}
                      rowsPerPage={this.state.rowsPerPage}
                      totalTasksCount={this.state.totalTasksCount}
                      page={this.state.page}
                      handleChangePage={this.handleChangePage}
                      handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                      sortBy={this.state.sortBy}
                      sortOrder={this.state.sortOrder}
                      updateSorting={this.updateSorting}
                      openTaskLink={this.openTaskLink}
                      selectReassignTask={this.selectReassignTask}
                      securityGroupsList={this.props.securityGroupsList}
                    />
                  </Card>
                </Grid>
              </Grid>
            </>
          )}
          {this.state.tabValue === 2 && (
            <>
              <Grid
                item
                style={{ position: "relative" }}
                size={{
                  xs: 12,
                }}
              >
                {/* <Card> */}
                <AddPartnerUser
                  tenantData={this.props.tenantData}
                  handleToggleDialog={this.handleToggleDialog}
                  submitData={this.createPartnerUser}
                  showAddNewUser={this.state.showAddNewUser}
                  userList={this.state.userList}
                  getUserList={this.getUserList}
                  showLoader={this.showLoader}
                />
                {/* </Card> */}
              </Grid>
            </>
          )}
          {this.state.showReassignTask && (
            <Dialog
              disableScrollLock={true}
              maxWidth={"xs"}
              PaperComponent={this.draggableDialogPaper}
              fullWidth={true}
              open={this.state.showReassignTask}
              aria-labelledby="delete-dialog-title"
              PaperProps={
                {
                  // className: jssClasses.resizablePaper
                }
              }
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                {t("REASSIGN_TASK")}
              </DialogTitle>
              <DialogContent dividers>
                <Grid
                  container
                  spacing={3}
                  justifyContent="center"
                  alignItems="center"
                  style={{ justifyContent: "center" }}
                >
                  {/* <Grid item xs={12}>
                                        <FormControl variant="outlined" className="custom-select-input" size={'small'}>
                                            <InputLabel htmlFor="outlined-age-native-simple">
                                                {t('SELECT_USER_TYPE')} *</InputLabel>
                                            <Select
                                                native
                                                label='select_user_type_ *'
                                                value={this.state.roleId}
                                                onChange={event => { this.onChangeRoleId(event) }}
                                                inputProps={{
                                                    name: 'roleId',
                                                    id: 'outlined-age-native-simple',
                                                }}
                                            >
                                                <option disabled value=''></option>
                                                {this.state.allUsersList.map(opt => (
                                                    opt.id !== 'SOLUTION_PROVIDER' &&
                                                    <option key={opt.id} value={opt.id}>{opt.name}</option>
                                                ))}
                                                {this.state.allUsersList.map(opt => (
                                                    opt.id === 'SOLUTION_PROVIDER' &&
                                                    <optgroup label={opt.name}>
                                                        {opt.providers && opt.providers.length > 0 && opt.providers.map(sOpt => (
                                                            <option key={sOpt.providerDetails.id} value={opt.id + ',' + sOpt.providerDetails.id}>{sOpt.providerDetails.name}</option>
                                                        ))}
                                                    </optgroup>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <FormControl
                      variant="outlined"
                      className="custom-select-input"
                      size={"small"}
                    >
                      <InputLabel htmlFor="outlined-age-native-simple">
                        {t("SELECT_EMPLOYEE")} *
                      </InputLabel>
                      <Select
                        native
                        label="select_employee_ *"
                        value={this.state.userId}
                        onChange={(event) => {
                          this.onChangeRoleId(event);
                        }}
                        inputProps={{
                          name: "userId",
                          id: "outlined-age-native-simple",
                        }}
                      >
                        <option disabled value=""></option>
                        {this.state.allUsersList.map((opt) => (
                          <option key={opt.employeeId} value={opt.employeeId}>
                            {opt.firstName + " " + opt.lastName}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  className="buttonSecondary"
                  onClick={(event) => this.reassignTaskUser(false)}
                  color="primary"
                >
                  {t("CANCEL")}
                </Button>
                <Button
                  onClick={(event) => this.reassignTaskUser(true)}
                  color="primary"
                  disabled={this.state.userId === ""}
                >
                  {t("REASSIGN")}
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </div>
        <Loader loading={this.state.loading} />
      </main>
    );
  }
}

// const styles = {

//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '0vw',
//     },
// };

const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
    tenantId: state.auth.tenantId,
    loggedInUserType: state.auth.userLoginType,
    access_token: state.auth.access_token,
    tenantData: state.auth.tenantData,
    countriesList: state.global.countriesList,
    apiPermissions: state.auth.apiPermissions,
    userPerms: state.auth.userPerms,
    securityGroupsList: state.auth.securityGroupsList,
    loggedInUserId: state.auth.loggedInUserId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setTenantData: (data) =>
      dispatch({ type: actionTypes.SET_TENANT_DATA, data }),
    setUserName: (data) =>
      dispatch({ type: actionTypes.UPDATE_USER_NAME_DATA, data }),
    setPendingTaskCount: (data) =>
      dispatch({ type: actionTypes.SET_PENDING_TASK_COUNT, data }),
    setSideMenu: (data) => dispatch({ type: actionTypes.SET_SIDE_MENU, data }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Provider)));
